import * as React from "react";
import { connect } from "react-redux";

const HouseholdPortfolioTableAccountNumber = ({ classes, custodian, portfolio }) => {
  const { accountNumberAbbreviation } = portfolio;

  if (!custodian) {
    return null;
  }

  if (!accountNumberAbbreviation) {
    return null;
  }

  return (
    <React.Fragment>
      ******{accountNumberAbbreviation}
    </React.Fragment>
  );
}

const mapStateToProps = (state, ownProps) => {
  const { portfolio } = ownProps;

  return {
    portfolio,
  };
};

export default connect(mapStateToProps)(HouseholdPortfolioTableAccountNumber);



// WEBPACK FOOTER //
// ./src/containers/HouseholdDetail/components/PortfolioTable/components/AccountNumber/index.jsx